import React from 'react';
import InlineCheckout from '../../checkout/InlineCheckout';
import ProPackagesLink from '../pro_packages_link';
import DiscountMessage from '../discount_message';
import ProductSelector from './product_selector';
import WinterSaleBanner from '../../components/WinterSaleBanner';
import { trackTiledCheckoutSelect } from '../../tracking/event';

const TiledPersonalProductsView = ({
  advertId,
  checkoutCart,
  checkoutView,
  currentProduct,
  discounts,
  experiments,
  paymentProviders,
  products,
  staticData,
  toggleCheckout,
  updateCart,
  winterSale,
  ...props
}) => {
  function handleSubmit() {
    trackTiledCheckoutSelect({
      label: `${currentProduct.name}|${currentProduct.price}|${advertId}`,
    });
    toggleCheckout();
  }
  return !checkoutView ? (
    <React.Fragment>
      <h4
        className="contact-form__upgrade-heading contact-form__upgrade-heading--tiled-experiment-v3"
        id="product-selector-heading"
      >
        2. {props.localisations.choose_your_upgrade}
      </h4>
      <menu className="products__options products__options--tiled-variation">
        <ProductSelector
          updateCart={updateCart}
          currentProduct={currentProduct}
          products={products}
          toggleCheckout={toggleCheckout}
          currencySymbol={staticData.site.currency_symbol}
          experiments={experiments}
          localisations={props.localisations}
        />
        <DiscountMessage discounts={discounts} />
        <ProPackagesLink
          product_description={checkoutCart.product_description}
          classBlock={'products'}
          context={staticData.miscellaneous.context}
          localisations={props.localisations}
        />
        <InlineCheckout
          affiliateId={staticData.affiliate.id}
          baseUrl={staticData.site.base_url}
          beforeSubmitErrorCheck={props.beforeSubmitErrorCheck}
          callback={props.storeOrderDetails}
          checkoutTotal={props.checkoutTotal}
          context={staticData.miscellaneous.context}
          currency_symbol={staticData.site.currency_symbol}
          currency={staticData.site.currency}
          currentProductId={currentProduct.id}
          experiments={experiments}
          paymentProviders={paymentProviders}
          paymentReturnUrls={props.stripeUrls}
          paymentSuccessCallback={props.paymentSuccessCallback}
          platform={props.context.platform}
          siteId={staticData.site.id}
          staticFilesServer={staticData.site.static_files_server}
          stripeButtonText={props.localisations.upgrade_and_send_message}
          upgradeContext={props.context.context}
          userId={staticData.customer.id}
          localisations={props.localisations}
          walletButtons={props.walletButtons}
        />
      </menu>
      {winterSale ? <WinterSaleBanner /> : null}
    </React.Fragment>
  ) : null;
};

export default TiledPersonalProductsView;
